var _rect, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenGradientBgWide422X400(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 400,
    viewBox: "0 0 422 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 422,
    height: 400,
    rx: 90,
    fill: "url(#paint0_linear_2_3028)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.972 123.114C420.954 123.25 420.791 123.361 420.608 123.361C325.864 123.361 103.84 135.019 0.351188 145.825C0.167831 145.844 0.0131883 145.75 0.00578392 145.616C-0.00162128 145.481 0.141017 145.356 0.324374 145.337C103.844 134.528 325.899 122.867 420.675 122.867C420.858 122.867 420.991 122.978 420.972 123.114Z",
    fill: "#BFD9C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.136 300.636C129.235 321.229 51.7223 344.629 3.81732 359.981C3.65919 360.032 3.44326 359.976 3.33503 359.857C3.22679 359.738 3.26723 359.6 3.42536 359.549C51.3395 344.194 128.864 320.79 207.782 300.194C286.689 279.6 367.021 261.805 420.537 257.682C420.719 257.668 420.914 257.761 420.972 257.89C421.03 258.019 420.929 258.135 420.746 258.149C367.316 262.265 287.048 280.042 208.136 300.636Z",
    fill: "#EDFFF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.147 70.4076C130.45 79.4754 50.6627 90.9666 0.404204 98.8943C0.226636 98.9224 0.0528222 98.8356 0.0159793 98.7006C-0.0208636 98.5656 0.0932163 98.4335 0.270784 98.4055C50.5385 90.4763 130.338 78.9833 210.05 69.9138C289.753 60.8453 369.398 54.1962 419.343 55.963C419.524 55.9694 419.664 56.0862 419.656 56.224C419.648 56.3617 419.494 56.4681 419.313 56.4617C369.439 54.6975 289.853 61.3388 210.147 70.4076Z",
    fill: "#BFD9C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.252 77.5118C133.425 80.298 52.6639 85.4678 0.322511 89.4051C0.136266 89.4191 -0.00797437 89.3225 0.000342312 89.1893C0.00866031 89.0562 0.166384 88.9369 0.35263 88.9229C52.7027 84.9849 133.477 79.8142 213.32 77.0275C293.155 74.241 372.089 73.8367 420.742 79.4384C420.92 79.4589 421.019 79.5828 420.964 79.7151C420.908 79.8474 420.719 79.9381 420.541 79.9176C371.96 74.3242 293.088 74.7253 213.252 77.5118Z",
    fill: "#BFD9C2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.985 52.599C137.318 49.4925 55.8868 48.6632 2.88148 48.4485C2.68877 48.4477 2.56967 48.3467 2.61546 48.2228C2.66126 48.099 2.8546 47.9992 3.04731 48C56.0577 48.2147 137.503 49.0441 217.188 52.1513C296.863 55.2582 374.815 60.6435 420.817 69.9768C420.99 70.0118 421.051 70.1364 420.954 70.2553C420.856 70.3741 420.638 70.442 420.465 70.407C374.542 61.0899 296.663 55.706 216.985 52.599Z",
    fill: "#BFD9C2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_3028",
    x1: 211,
    y1: 0,
    x2: 211,
    y2: 400,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580345,
    stopColor: "#008080",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008080",
    stopOpacity: 0.26
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenGradientBgWide422X400);
export default __webpack_public_path__ + "static/media/green-gradient-bg-wide-422x400.7071d8e8e3a75775b821a76921f21fc2.svg";
export { ForwardRef as ReactComponent };